import axios from "axios";
import * as Config from "./config";

async function reqContactenos() {
  const API_URI_CONTACTENOS = Config.Contactenos;
  try {
    const response = await axios.get(API_URI_CONTACTENOS);
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}
//eslint-disable-next-line
export default {
  reqContactenos,
};
